import type { FormFieldDto } from '../../form.types';
import { CHOICE_CONTROL_CLASS } from './field.styles';

interface FormFieldCheckboxProps {
    field: FormFieldDto;
}

export function FormFieldCheckbox({ field }: FormFieldCheckboxProps) {
    return (
        <div className="form-choice-group md:col-span-2">
            {field.choices?.map((choice) => (
                <label key={choice.value} className="form-choice">
                    <input
                        type="checkbox"
                        name={`${field.name}[]`}
                        value={choice.value}
                        className={CHOICE_CONTROL_CLASS}
                    />
                    <span>{choice.label}</span>
                </label>
            ))}
        </div>
    );
}
